module.exports = __webpack_public_path__ + "static/img/k24_kw_02.14d46fea.png";